// Auto-generated skeleton for DocumentType

export const DocumentType: Api.DocumentType = {
  id: 0,
  ordering: 0,
  acronym: null,
  name: null,
  documents_size: 0,
  documents_count: 0,
  notify: false,
  notify_of_weeks: 0,
  created: null,
  updated: null,
};

